export default __webpack_public_path__ + "static/media/map.a46c842b.png";